import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Component({
    selector: 'app-vendors',
    templateUrl: './vendors.component.html',
    styleUrls: ['./vendors.component.css']
})
export class VendorsComponent implements OnInit {

    public salesVPerson = null;
    public vendorSelected = null;
    public vendors = null;

    constructor(private authService: AuthService) {
        this.salesVPerson = this.authService.getVendors();
    }

    ngOnInit() {
        this.vendorList();
    }

    vendorList() {
        if (!localStorage.getItem("vendSelected")) {
            this.vendorSelected = this.salesVPerson[0];
        } else {
            this.vendorSelected = JSON.parse(localStorage.getItem("vendSelected"));
        }
        this.vendors = this.salesVPerson;
    }

    changeVendor(id: any) {
        this.vendorSelected = this.vendors[id];
        localStorage.setItem("vendSelected", JSON.stringify(this.vendorSelected));
    }
}
